import { Checkbox, Field, TextOutput } from 'Components/Core';
import { Grid, PageSection } from 'Components/Layout';
import { actions } from 'Data/ReduxViewModels/InterLab';
import { IInterLabSampleModel } from 'Data/ReduxViewModels/InterLab/types';
import { Severity } from 'Data/ViewModels/Core/Severity';
import deepEquals from 'Lib/Object/deepEquals';
import { orderBy } from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IInterLabSharedComponentProps } from '../types';

const InterLabAffectedSamples: React.FC<IInterLabSharedComponentProps> = ({ actionOption }) => {
  const dispatch = useDispatch();

  const samples = useSelector((state) => state.interLab.workOrder?.samples || [], deepEquals);

  const noSamplesLoaded = samples.length === 0;
  const allSamplesSelected = !noSamplesLoaded && samples.every((x) => x.checked);

  const handleCheckChange = (sample: IInterLabSampleModel) => {
    dispatch(actions.updateSample({ ...sample, checked: !sample.checked }));
  };

  const handleCheckChangeForAllSamples = () => {
    dispatch(actions.updateAllSample(!allSamplesSelected));
  };

  const OutputField = (value?: any, severity?: Severity) => (
    <Field input={<TextOutput />} severity={severity} value={value} />
  );

  return (
    <PageSection heading="Affected Samples">
      <Grid
        colWidths={[20]}
        minColWidths={[0, 0, 200, 220, 300, 0, 200]}
        colHeaders={[
          <Field
            input={<Checkbox />}
            disabled={noSamplesLoaded}
            onChange={() => handleCheckChangeForAllSamples()}
            value={allSamplesSelected}
          />,
          'Sample ID',
          'Sub-Sample ID',
          'General Location',
          'Location',
          'Sampling Type',
          'Sample Pickup Notes',
        ]}
        hiddenCols={actionOption === 'transfer' ? [0, 2] : undefined}
        data={orderBy(samples, (s) => s.sampleId)?.map((d, _) => [
          <Field input={<Checkbox />} onChange={() => handleCheckChange(d)} value={d.checked ?? false} />,
          OutputField(d.sampleId),
          OutputField(
            d.checked === true ? d.subSampleId : '',
            d.isSubSampleIdTooLong && d.checked ? 'error' : undefined
          ),
          OutputField(d.generalLocation),
          OutputField(d.location),
          OutputField(d.samplingType),
          OutputField(d.samplePickupNotes),
        ])}
      />
    </PageSection>
  );
};

export { InterLabAffectedSamples };
